import { Typography } from '@psl/components/typography';
import { useResponsiveContext } from '@psl/functions/responsive/ResponsiveContext';
import { HeaderTitle } from '@react-navigation/elements';
import color from 'color';
import { View } from 'react-native';

export const OnboardingPostPageHeaderTitle = (
  props: Parameters<typeof HeaderTitle>[0],
) => {
  const { rpx } = useResponsiveContext();

  if (typeof props.children !== 'string') {
    return <></>;
  }
  if (props.children.includes('\n')) {
    const [title, subtitle] = props.children!.split('\n');
    // $hack(eric): allow use directive/modifier in form of
    // `!color[#aabbcc] text` to set the sub title color.
    const m = subtitle ? /^!color\[(.+?)\]\s(.+?)$/.exec(subtitle) : null;
    const subTitleColor =
      m?.[1] ??
      (props.tintColor ? color(props.tintColor).fade(0.6).string() : '#777');
    const subTitle = m?.[2] || subtitle;
    return (
      <View
        css={`
          align-items: center;
        `}
      >
        <HeaderTitle {...props}>{title}</HeaderTitle>
        <Typography.Label
          size={rpx(12)}
          lineHeight={rpx(18)}
          light
          color={subTitleColor}
        >
          {subTitle}
        </Typography.Label>
      </View>
    );
  }
  return <HeaderTitle {...props} />;
};
